module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/banner/vi-0ff4317d1ade3c4f0e7d1a1394801f59.jpg";